import clsx from 'clsx';
import { FadeIn } from 'components/common/FadeIn';
import Gift from '../svg/EnterFlowInfoGraphic/gift.svg';
import People from '../svg/EnterFlowInfoGraphic/people.svg';
import Verified from '../svg/EnterFlowInfoGraphic/verified.svg';
import Mascot from '../svg/Mascots/phone.svg';
import styles from './TitleSection.module.css';

export const InfoGraphicRow = ({
  lightMode,
  desktopVersion,
}: {
  lightMode?: boolean;
  desktopVersion?: boolean;
}) => {
  return (
    <div
      className={clsx(
        styles.infoGraphicContainer,
        lightMode && styles.lightMode,
        desktopVersion && styles.bottomLine,
      )}
    >
      <div className={styles.infoGraphic}>
        <Verified />
        <div className="daymadeTypographySRegular">Cancel anytime</div>
      </div>
      <div className={styles.infoGraphic}>
        <People />
        <div className="daymadeTypographySRegular">12m of prizes won</div>
      </div>
      <div className={styles.infoGraphic}>
        <Gift />
        <div className="daymadeTypographySRegular">450+ prizes</div>
      </div>
    </div>
  );
};

interface TitleSectionProps {
  displayMascot?: boolean;
  lightMode?: boolean;
  showInfoGraphic?: boolean;
  subtitle?: string;
  title?: string | React.ReactNode;
}

const TitleSection = ({
  displayMascot,
  lightMode,
  showInfoGraphic,
  subtitle,
  title,
}: TitleSectionProps) => {
  if (!title && !subtitle && !displayMascot) return null;

  return (
    <div
      className={clsx(
        styles.titleSectionContainer,
        lightMode && styles.lightMode,
      )}
    >
      <FadeIn onScroll duration={0.3} className={styles.header}>
        <h1 className={clsx(styles.title, 'daymadeTypographyXXL')}>
          {title}
          {displayMascot && (
            <span className={styles.mascot}>
              <Mascot />
            </span>
          )}
        </h1>
      </FadeIn>
      <FadeIn
        onScroll
        duration={0.3}
        delay={0.05}
        className={clsx(styles.subtitle, 'daymadeTypographyMRegular')}
      >
        {subtitle}
      </FadeIn>
      {showInfoGraphic && (
        <FadeIn onScroll duration={0.3} delay={0.1}>
          <InfoGraphicRow />
        </FadeIn>
      )}
    </div>
  );
};

export default TitleSection;
